import { render, staticRenderFns } from "./catalog_review_modal.vue?vue&type=template&id=82149c1e&scoped=true&"
import script from "./catalog_review_modal.vue?vue&type=script&lang=js&"
export * from "./catalog_review_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82149c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82149c1e')) {
      api.createRecord('82149c1e', component.options)
    } else {
      api.reload('82149c1e', component.options)
    }
    module.hot.accept("./catalog_review_modal.vue?vue&type=template&id=82149c1e&scoped=true&", function () {
      api.rerender('82149c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/reviews/item/catalog_review_modal.vue"
export default component.exports